export const INSTRUMENTATION_NAME = '@sentry/instrumentation-http';
